import React from 'react'
import {FaTimes, FaPlus} from 'react-icons/fa'

export const NewProject = ({status,close}) =>{
    const closeModal = (e) => {
        e.preventDefault()
        close(false);
      } 

    return status ? (
        <React.Fragment> 
          <div className="project-create-modal">
                <div className="project-heading-light">
                    <div>
                        <h3>Create new project</h3>
                        <p>In few minutes you can create a project easly</p>
                    </div>
                    <FaTimes size={18} onClick={e=>{
                    e.preventDefault()
                    closeModal(e)
                }} />
                </div>

                <div className="form">
                {/** 
                   <div className="profile_component">
                        <Skills data={skillList} />
                        <Skills type="personal" title="Personal skills" data={skillList2} />
                        <ChooseComponent 
                           type="new-project"
                        />
                        <Featuring data={jobList} name="Educations" type="edu" />
                        <Featuring name="Experiments" data={jobList} type="exp"  />
                        <Featuring name="Courses" data={jobList} type="course" />
                        <Langs />
                    </div>
                 */}
                
                    <div className="">
                        <p>Project title</p>
                        <input type="text" name="title" />
                    </div>

                    <div className="">
                        <p>Project description</p>
                        <textarea name="desc"></textarea>
                    </div>
                    <div className="mt-4">
                        <h4>Team members</h4>
                        <div className="project-team">
                            <div className="persons">  
                                <div><img src="/assets/images/faces/12.png" alt="" /></div>
                                <div><img src="/assets/images/faces/13.png" alt="" /></div>
                                <div><img src="/assets/images/faces/14.png" alt="" /></div>
                                <div><img src="/assets/images/faces/11.png" alt="" /></div>
                             
                            </div>
                            <div className="add-person">
                                <FaPlus />
                            </div>
                        </div>
                    </div>

         

                    <div className="mt-4 check-form">
                    <p>Privacy</p>
                    <div>
                        <div className="check">
                            <input type="radio" name="status" id="status1" />
                            <div>
                                  <label htmlFor="status1">
                                      Public
                                     <p>Everyone can see this project</p>
                                 </label>
                            </div>
                        </div>
                        <div className="check">
                            <input type="radio" name="status"  id="status2" />
                            <div>
                                <label htmlFor="status2">Privacy
                                <p>Only team members can see</p>
                                </label>
                            </div>
                        </div>
                        <div className="check">
                            <input type="radio" name="status"  id="status3" />
                            <div>
                                <label htmlFor="status3">Private
                                <p>No body can see without you</p>
                                </label>
                            </div>    
                        </div>
                        <div>
                            <div><i className="fa fa-a"></i> Share </div>
                            <div><i className="fa fa-question-circle"></i>Faq</div>
                        </div>
                    </div>

                    <div style={{height:'100px'}}></div>
                </div>

                </div>
      
            </div>
            <div 
                className="overlay"  
                onClick={e=>closeModal(e)}
            ></div>
    </React.Fragment>
    ) : <React.Fragment></React.Fragment>
}
